import { useRetailer } from "@faire/retailer-visitor-shared/hooks/retailer/useRetailer";
import { useSettingAndAssignMigrateRetailerStore } from "@faire/retailer-visitor-shared/settings/useSettingMigrateRetailerStore";
import { useRetailerStore } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";
import addDays from "date-fns/addDays";
import { useMemo } from "react";
export var useIsRetailerCreatedWithinLast30Days = function() {
    var shouldUseHooksMigration = useSettingAndAssignMigrateRetailerStore();
    var retailer = useRetailer().retailer;
    var _useRetailerStore = useRetailerStore([
        "isRetailerCreatedWithinLast30Days"
    ]), isRetailerCreatedWithinLast30DaysControl = _useRetailerStore.isRetailerCreatedWithinLast30Days;
    var isRetailerCreatedWithinLast30Days = useMemo(function() {
        if (!(retailer === null || retailer === void 0 ? void 0 : retailer.created_at)) {
            return false;
        }
        return addDays(new Date(retailer === null || retailer === void 0 ? void 0 : retailer.created_at), 31) > new Date();
    }, [
        retailer === null || retailer === void 0 ? void 0 : retailer.created_at
    ]);
    if (shouldUseHooksMigration) {
        return {
            isRetailerCreatedWithinLast30Days: isRetailerCreatedWithinLast30Days
        };
    }
    return {
        isRetailerCreatedWithinLast30Days: isRetailerCreatedWithinLast30DaysControl
    };
};
